import ContractTemplatesView from '../ContractTemplatesView.vue'
import ContractTemplateList from '../Pages/ContractTemplateList.vue'
import ContractTemplateEditor from '../Pages/ContractTemplateEditor.vue'

const routes = [
  {
    path: '/contratos/plantillas',
    component: ContractTemplatesView,
    children: [
      {
        path: '',
        name: 'contract-template-list',
        component: ContractTemplateList,
      },
      {
        path: 'nueva',
        name: 'contract-template-create',
        component: ContractTemplateEditor,
      },
      {
        path: ':id/editar',
        name: 'contract-template-edit',
        component: ContractTemplateEditor,
      },
    ],
  },
  // Redirección desde la ruta antigua (Mantenimiento → Contratos) para no romper enlaces guardados.
  {
    path: '/mantenimiento/plantillas-contrato',
    redirect: '/contratos/plantillas',
  },
]

export default routes
